import {useContext} from 'react';

import {Navigate, Outlet, useLocation} from 'react-router-dom';

import {UserContext} from '../../contexts/UserContext/UserContext';
import {AppConfig} from '../../lib/AppConfig';

export const LoggedInGuard = () => {
  const {currentUser, isLoading} = useContext(UserContext);
  const currentPath = useLocation().pathname;
  const isVerifyPage = currentPath.includes('account/verify');
  const guardPassed = currentUser || isVerifyPage;

  if (isLoading) {
    return null;
  }

  return guardPassed ? <Outlet /> : <Navigate to={AppConfig.LOGIN_PATH} />;
};
